import React from "react"

import {ProviderEdit} from "components/backoffice/Storage/Provider/Edit/ProviderEdit"

export const ProviderAddRoute = (props: any) => {

  return <div>
    <ProviderEdit open />
  </div>
}